module.exports = "<template>\r\n\t<div ref=\"recaptchaCheckbox\"></div>\r\n</template>\r\n";